export enum AppRoutes {
  DASHBOARD = '/dashboard',
  SITES = '/sites',
  NODES = '/nodes',
  CLI = '/cli',
  CLIENTS = '/clients',
  TASKS = '/tasks',
  TEAMS = '/teams',
  SETTINGS = '/settings',
  EVENT_LOG = '/events',
  NOTIFICATIONS = '/notifications',
  LANDING = '/',
}
